import { render, staticRenderFns } from "./CompanyStandardDialog.vue?vue&type=template&id=01cb6b82&scoped=true"
import script from "./CompanyStandardDialog.vue?vue&type=script&lang=js"
export * from "./CompanyStandardDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyStandardDialog.vue?vue&type=style&index=0&id=01cb6b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb6b82",
  null
  
)

export default component.exports